var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        { attrs: { "border-color": "secondary-2", "has-toggle": false } },
        [
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-md-3 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Nombre: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [_vm._v(" " + _vm._s(_vm._f("empty")(_vm.item?.name)) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Puesto: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.item?.chargeName)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-3 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Tipo de Participación: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.item?.participantType?.name)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Área: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [_vm._v(" " + _vm._s(_vm._f("empty")(_vm.item?.area)) + " ")]
              )
            ]),
            !_vm.isReadonly
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-md-1 col-12 d-flex justify-content-md-end justify-content-start"
                  },
                  [
                    _c("action-button", {
                      staticClass: "mr-2 px-3",
                      attrs: {
                        i: "fas fa-times-circle",
                        text: "",
                        variant: "outline-danger"
                      },
                      on: { click: _vm.remove }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }